import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/dome-turret/g6-dome.png";
import type { Product } from "../../types";
import { domeTurret as productListDomeTurret } from "../product-list-groups/domeTurret";
import { deployment, outdoorReady } from "../properties";

export const g6Dome: Product = {
  id: "g6Dome",
  productTitle: "G6 Dome",
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-g6-dome`],
  storePathParts: {
    productSlug: "uvc-g6-dome",
    category: "cameras-dome-turret",
  },
  description: "g6Dome.description",
  image: { src: image, width: 200, height: 140 },
  productListGroup: productListDomeTurret,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø144.7x 96.3 mm\n(Ø5.7 x 3.8")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g6Dome.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "g6Dome.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "commons.cameraAudio.microphone",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK10" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
